<template>
  <a-layout class="video-local">
    <video id="local-video" ref="video" class="media media--contain" autoplay muted playsinline></video>
    <a-announcement v-if="state.matches('app.camera.notAvailable')" icon="camera-off"
      :message="$t('announcement.cameraNotAvailable')" />
  </a-layout>
</template>

<script setup>
import { onUnmounted, ref, watchEffect } from 'vue'
import { storeToRefs } from 'pinia'
import { useTransformStore, useAppStore, useUserStore } from '@/stores'
import { useLocalStream } from '@/composables'
import { procedures } from '@communication'
import { messenger } from '@communication'
import useMeetingMachine from '../../../../../state/useMeetingMachine'

const props = defineProps({ mode: String })

const app = useAppStore()
const transform = useTransformStore()
const user = useUserStore()
const { video: localVideoStream } = useLocalStream()

const video = ref(null)
const { zoom, x, y } = storeToRefs(transform)
const {state} = useMeetingMachine()


watchEffect(() => {
  if (video?.value) {
    video.value.srcObject = localVideoStream.value
  }
})

user.$onAction(({ name, args }) => {
  if (name === 'setPresence') {
    const [present] = args
    if (present && app.state.matches('app.camera.notAvailable')) {
      procedures.get('destroyProcedure').destroy()
    }
  }
})

onUnmounted(() => {
  messenger.unsubscribe('callVideoLocal')
})

</script>

<style lang="scss">
$video-bg: $black;

.video-local {
  background-color: $video-bg;
  z-index: $zindex-video;
  touch-action: none;

  video {
    transition-property: transform;
    transition-duration: $duration-fast;
    transform-origin: 0 0;
    transform: matrix(v-bind(zoom), 0, 0, (v-bind(zoom), v-bind(x), v-bind(y)));
  }
}
</style>

